<template>
    <li class="nav-item"><router-link :to="'/content/'+ navigationItem.slug" class="nav-link">{{ navigationItem.linkText}}</router-link></li>
</template>

<script>
export default {
  name: 'navigation-item',
  props: ['navigationItem'],
};
</script>



// WEBPACK FOOTER //
// src/components/common/NavigationItem.vue